import { ArticleHeading2, ArticleHeading4 } from '@cian/ui-kit';

import * as styles from './Title.css';

export interface ILinkProps {
  mainTitle: string | undefined;
  secondTitle: string;
  href: string;
  onClick?(): void;
}

export const Title = ({ mainTitle, secondTitle, href, onClick }: ILinkProps) => {
  return (
    <a
      className={styles['link']}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={event => {
        event.stopPropagation();

        if (onClick) {
          onClick();
        }
      }}
    >
      <ArticleHeading2 data-name="LinkTitle" color="text-main-default">
        {mainTitle || secondTitle}
      </ArticleHeading2>
      {mainTitle && <ArticleHeading4 data-name="SecondTitle">{secondTitle}</ArticleHeading4>}
    </a>
  );
};
